import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getConfigurationValue } from 'dmpconnectjsapp-base/helpers/accessors';
import { API_TYPES } from 'dmpconnectjsapp-base/constants';
import CenteredCard from '../Common/Card/CenteredCard';
import CenteredLoading from '../Common/Loading/CenteredLoading';
import CheckConnector from './CheckConnector';
import CheckLicense from './CheckLicense';
import CheckConnectorVersion from './CheckConnectorVersion';
import CheckConnectorRest from './CheckConnectorRest';

const INIT_STEP = {
  CONNECTOR: 1,
  SESSION: 2,
  VERSION: 3,
  LOGIN: 4,
  LICENSE: 5,
  END: 6,
};

class InitApp extends Component {
  getStatus() {
    const {
      connectorOk, sessionOk, connectorVersionOk, licenseOk,
    } = this.props;

    if (!connectorOk) return INIT_STEP.CONNECTOR;
    if (!connectorVersionOk) return INIT_STEP.VERSION;
    if (!sessionOk) return INIT_STEP.SESSION;
    if (!licenseOk) return INIT_STEP.LICENSE;

    return INIT_STEP.END;
  }

  render() {
    const {
      licenseError, logoutPending, version, minimumVersion, apiType,
    } = this.props;
    const status = this.getStatus();
    const loadingMessage = logoutPending ? 'Déconnexion' : 'Initialisation';
    return (
      <div className="centered-container">
        {status !== INIT_STEP.END ? (
          <>
            {
              {
                [INIT_STEP.CONNECTOR]: (
                  <>
                    {
                      apiType === API_TYPES.REST
                        ? <CheckConnectorRest />
                        : <CheckConnector versionMinimum={minimumVersion} />
                    }
                  </>
                ),
                [INIT_STEP.SESSION]: <CenteredCard>Ouverture de session</CenteredCard>,
                [INIT_STEP.VERSION]: <CheckConnectorVersion version={version} versionMinimum={minimumVersion} />,
                [INIT_STEP.LICENSE]: <CheckLicense error={licenseError} />,
              }[status]
            }
          </>
        ) : (
          <CenteredCard>
            <CenteredLoading message={loadingMessage} />
          </CenteredCard>
        )}
      </div>
    );
  }
}

InitApp.propTypes = {
  connectorOk: PropTypes.bool.isRequired,
  sessionOk: PropTypes.bool.isRequired,
  licenseOk: PropTypes.bool.isRequired,
  connectorVersionOk: PropTypes.bool.isRequired,
  logoutPending: PropTypes.bool.isRequired,
  licenseError: PropTypes.object,
  version: PropTypes.string,
  minimumVersion: PropTypes.string,
  apiType: PropTypes.string.isRequired,
};

InitApp.defaultProps = {
  licenseError: {},
  version: '',
  minimumVersion: '',
};

function mapStateToProps(state) {
  const {
    dmpconnectInit: {
      connectorOk,
      sessionOk,
      connectorVersionOk,
      licenseOk,
      licenseError,
      version,
    },
    dmpconnectUser: { logoutPending },
    dmpconnectConnectorConfig,
  } = state;
  return {
    connectorOk,
    sessionOk,
    logoutPending,
    connectorVersionOk,
    licenseOk,
    licenseError,
    version,
    minimumVersion: getConfigurationValue('dmpcjsVersion', dmpconnectConnectorConfig),
    apiType: getConfigurationValue('apiType', dmpconnectConnectorConfig),
  };
}

const connectedInitApp = connect(mapStateToProps)(InitApp);

export default connectedInitApp;
